import React from 'react';
import PropTypes from 'prop-types';
import SimpleFeedItem from './SimpleFeedItem';
import './SimpleFeed.scss';


const propTypes = {
    simpleFeeds: PropTypes.array
};


export default class SimpleFeed extends React.Component{
    constructor (props) {
        super(props);
    }

    render() {

        const{simpleFeeds} = this.props;

        return(
            <div className='simple-feed-row'>
                {this.props.simpleFeeds.map((simpleFeed, index) => (
                    <SimpleFeedItem key={index} feedItem={simpleFeed}/>
                ))}
            </div>
        )
    }
}

SimpleFeed.propTypes = propTypes;


// WEBPACK FOOTER //
// ./src/components/SimpleFeed/index.js